//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockLocationCtrl', {
//        templateUrl: 'views/components/views/stockLocationCtrl/stockLocationCtrl.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'stockLocationCtrlService', 'stockCountsService', 'rememberService', function ($stateParams, stateService, utilityService, modalService, translateService, stockLocationCtrlService, stockCountsService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;

//            let variableNames = {
//                compare_with_stockcount: '',
//                stockcount_keyno: ''
//            };

//            let translations = {
//                stocklocationctrl_sum: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                translations: {
//                    stocklocationctrl_sum: ''
//                },
//                selectListStockCounts: [],
//                inputListControllers: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS
            
//            async function loadEdit() {
//                vm.model.edit = (await stockLocationCtrlService.getEdit({ stock_keyno: stockKeyno }))[0];
//            }
            
//            async function loadStockCounts() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id) !== true) return;
                
//                return vm.model.selectListStockCounts = await stockCountsService.listStockCounts({
//                    stockplace_id: vm.model.edit.stockplace_id,
//                    bg_stockcount_status: 'ALL'
//                });
//            }
            
//            async function loadControllers() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockcount_keyno) !== true) return;

//                return stockLocationCtrlService.listControllers(vm.model.edit).then(function (list) {
//                    vm.model.inputListControllers = list;
//                    recalcAll();
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'compare_with_stockcount':
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'compare' + '.' + vm.model.edit.stockplace_id;
//                            break;
//                        case 'stockcount_keyno':
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'stockcount_keyno' + '.' + vm.model.edit.stockplace_id;
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'compare_with_stockcount':
//                    case 'stockcount_keyno':
//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        variableValue = vm.model.edit[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RECALC FUNCTIONS
            
//            async function recalcAll() {
//                recalcSumQuantityStock();
//                recalcSumQuantityStockCount();
//                recalcSumQuantityControlled();
//            }
            
//            function recalcSumQuantityStock() {
//                let recalcSum = 0;

//                vm.model.inputListControllers.forEach((data) => {
//                    if (data.quantity_stock === undefined || data.quantity_stock === null || data.quantity_stock === '') {
//                        recalcSum += 0;
//                    } else {
//                        recalcSum += utilityService.parseNumber(data.quantity_stock);
//                    }
//                });
                
//                vm.model.edit.sum_quantity_stock = recalcSum.toString();
//            }
            
//            function recalcSumQuantityStockCount() {
//                let recalcSum = 0;
                
//                vm.model.inputListControllers.forEach((data) => {
//                    if (data.quantity_stockcount === undefined || data.quantity_stockcount === null || data.quantity_stockcount === '') {
//                        recalcSum += 0;
//                    } else {
//                        recalcSum += utilityService.parseNumber(data.quantity_stockcount);
//                    }
//                });
                
//                vm.model.edit.sum_quantity_stockcount = recalcSum.toString();
//            }
            
//            function recalcSumQuantityControlled() {
//                let recalcSum = 0;
                
//                vm.model.inputListControllers.forEach((data) => {
//                    if (data.quantity_controlled === undefined || data.quantity_controlled === null || data.quantity_controlled === '') {
//                        recalcSum += 0;
//                    } else {
//                        recalcSum += utilityService.parseNumber(data.quantity_controlled);
//                    }
//                });
                
//                vm.model.edit.sum_quantity_controlled = recalcSum.toString();
//            }

//            // #endregion RECALC FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                let mergeObj = vm.model.edit;
//                mergeObj.records = vm.model.inputListControllers;

//                stockLocationCtrlService.saveObj(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id, item) {
//                switch (id) {
//                    case 'compare_with_stockcount':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.compare_with_stockcount) !== true) return;

//                        vm.model.edit.compare_with_stockcount = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.compare_with_stockcount) !== true) return;

//                        rememberFunc('compare_with_stockcount');
//                        break;
//                    case 'stockcount_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.stockcount_keyno) !== true) return;

//                        vm.model.edit.stockcount_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.stockcount_keyno, true) !== true) return;

//                        rememberFunc('stockcount_keyno');
//                        loadControllers();
//                        break;
//                    case 'quantity_controlled':
//                        if (utilityService.validateWatchValue(value, item.quantity_controlled) !== true) return;

//                        item.quantity_controlled = value;

//                        if (utilityService.validateParmsValue(item.quantity_controlled, true) !== true) return;

//                        recalcSumQuantityControlled();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();

//                vm.model.translations.stocklocationctrl_sum = translations.stocklocationctrl_sum;

//                loadStockCounts();
//                loadControllers();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
